import React, { useEffect, useState } from 'react';
import './GarageList.css'
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import Loading from '../loading/Loading'
import { useSelector } from "react-redux";
import { format } from 'date-fns';

function SearchGarageList({ garagesList, actions, column }) {
  const [garages, setGarages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading Garages, Please Wait...')
  const profile_complete = useSelector(state => state.user.profile_complete);

  const showTime = format(new Date(), 'MMddyyyyHis');
  useEffect(() => {
    if (garagesList && Object.keys(garagesList).length) {
      setLoading(true);
      const getGaragesComponents = (garage, element) => {
      //  console.log('element',element)
        return (
          <div key={garage} className={`col-xl-${column ? column : 6} col-lg-${column ? column : 6} col-md-6 col-sm-6`}>
            <div className="sale-item">

              <Link to={`/garages-details/${element.id}`} className='garage' >
                <div className="garage__img">
                  <img className="garage__image"  
                  style={{ transform: `rotate(${element.garagePicturesA[0] ? element.garagePicturesA[0] : 0}deg)` }}
                  
                  src={`${element.garagePictures[0] ? `${process.env.REACT_APP_UPLOAD_URL + element.garagePictures[0]}?time=${showTime}` : './assets/Images/garage-placeholder.png'}`} alt='garage'></img>

                  {/* <span className="item-status">For Sale</span> */}
                </div>
                <div className="item-info">

                  <div className="specs-info">
                    <p className="garage__access"><label className="garage__label">Area : </label> {(element.length * element.width) || 0}</p>
                    <p className="garage__access"><label className="garage__label">Access : </label> {element.sideDoor ? 'Side Door' : 'Only Garage'}</p>
                    <p className="garage__door"><label className="garage__label">Door : </label> {element.doorOpener ? 'Has door opener' : 'Only main door'}</p>
                    {(profile_complete== true) &&
                      <>
                        <p className="garage__door"><label className="garage__label">Neighborhood : </label> {element.neighborhood}</p>
                        <p className="garage__door"><label className="garage__label">Address : </label> {element.address}, {element.city}</p>
                      </>
                    }
                    <p className="garage__door"><label className="garage__label">Price : </label> {element.rentalRate}USD</p>


                  </div>
                </div>
              </Link>
            </div>
          </div>



        );
      };

      async function getGarages(garagesList) {
        let garagesContainer = [];
        try {
          for (const garage in garagesList) {
            if (garagesList.hasOwnProperty(garage)) {
              const element = garagesList[garage];
              garagesContainer.push(getGaragesComponents(garage, element));
            }
          }
          return garagesContainer;
        } catch (err) {
          throw err;
        }
      }

      getGarages(garagesList).then(resp => {
        //console.log('Garages results', resp);
        setGarages(() => [
          resp
        ]);

        if (resp.length > 0) {

          setTimeout(() => {
            setLoading(false);
          }, 500);
        } else {

          setLoading(true);
          setLoadingText("Oops, no garages found");
        }
      });
    } else {
      setGarages(() => { });
      setLoading(() => false);
      // setLoadingText("Loading...");
    }
  }, [garagesList, actions])

  return (loading ?
    <Loading text={loadingText} />
    :
    <div className='row m-auto'>
      <li id='labels'>
        <span></span>
        <p>Area</p>
        <p>Access</p>
        <p>Door</p>
        <p>Description</p>
      </li>
      {garages ? garages : <div style={{minHeight:'500px'}}><span>There are no garages to show</span></div>}
    </div>
  )
}

export default SearchGarageList